import {ItemSelector} from "./item-selector";

export class ItemSelectorBuilder {

    constructor(){
        this.items = {};
        this.config = {};
        this.validations = {};
    }

    items :any;
    config :any;
    validations :any;

    withItems(anotherItems) {
        this.items = anotherItems;
        return this;
    };
    withListOfItemsTitle(listOfItemsTitle) {
        this.config['listOfItemsTitle'] = listOfItemsTitle;
        return this;
    };

    withListOfSelectedItemsTitle(listOfSelectedItemsTitle) {
        this.config['listOfSelectedItemsTitle'] = listOfSelectedItemsTitle;
        return this;
    };

    withValidations(anotherValidations) {
        this.validations = anotherValidations;
        return this;
    };

    build() {
        return new ItemSelector(this.config, this.items, this.validations);
    };
}


// WEBPACK FOOTER //
// ./public/upgrade/shared/sara-selector/item-selector-builder.ts